import { Page } from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'

export function PromotionsList(props: DefaultProps) {
  const { children } = props

  return <Page>{children}</Page>
}
